var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useDispatch, useSelector } from 'react-redux';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSearch } from '@fortawesome/pro-solid-svg-icons/faSearch';
import Select from 'react-select';
import { useParams } from 'react-router-dom';
import { templateOptions } from '../assets/data';
import { SearchFilterContainer, SearchFilterDropdownContainer, SearchFilterInputContainer, SearchInput, } from '../styles';
import { setTemplateType, searchTemplates, setSearchType, activeSearchTemplates, clearActiveSearchResults, clearSelectedTemplate, } from '@project/store/createAppFlow/actions';
import { selectAppCreationFlow } from '@project/store/createAppFlow/selectors';
var SearchFilter = function (_a) {
    var currentType = _a.currentType;
    var dispatch = useDispatch();
    var params = useParams();
    var _b = useSelector(selectAppCreationFlow), searchText = _b.searchText, templateType = _b.templateType, categoryString = _b.categoryString;
    var onSearchTemplates = function (text) {
        dispatch(searchTemplates(text));
        dispatch(clearActiveSearchResults());
        dispatch(clearSelectedTemplate());
        if (templateType === null) {
            dispatch(setTemplateType('all'));
        }
        dispatch(activeSearchTemplates(params === null || params === void 0 ? void 0 : params.organizationId, categoryString, 1, text, templateType, []));
    };
    var onTemplateTypeChange = function (value) {
        dispatch(clearActiveSearchResults());
        dispatch(clearSelectedTemplate());
        dispatch(setTemplateType(value));
        if (value === 'legacy') {
            dispatch(activeSearchTemplates(params.organizationId, categoryString, 1, searchText, 'legacy', []));
        }
        else {
            if (value === 'all') {
                dispatch(setSearchType(null));
                dispatch(activeSearchTemplates(params === null || params === void 0 ? void 0 : params.organizationId, categoryString, 1, searchText, 'all', []));
            }
            else {
                dispatch(setSearchType(value));
                dispatch(activeSearchTemplates(params === null || params === void 0 ? void 0 : params.organizationId, categoryString, 1, searchText, value, []));
            }
        }
    };
    return (_jsxs(SearchFilterContainer, { children: [_jsxs(SearchFilterInputContainer, { children: [_jsx(FontAwesomeIcon, { style: { marginRight: '8px' }, color: "#C2C2C2", size: "sm", icon: faSearch }), _jsx(SearchInput, { value: searchText, type: "text", placeholder: "Search All Templates", onChange: function (e) { return onSearchTemplates(e.target.value); } })] }), _jsx(SearchFilterDropdownContainer, { children: _jsx(Select, { options: templateOptions, value: templateOptions.find(function (font) { return (font === null || font === void 0 ? void 0 : font.value) === (currentType || 'all'); }), styles: {
                        control: function (baseStyles) { return (__assign(__assign({}, baseStyles), { fontSize: '13px' })); },
                        option: function (baseStyles) { return (__assign(__assign({}, baseStyles), { fontSize: '13px' })); },
                        input: function (baseStyles) { return (__assign(__assign({}, baseStyles), { height: '20px' })); },
                    }, theme: function (theme) { return (__assign(__assign({}, theme), { colors: __assign(__assign({}, theme.colors), { primary25: '#f5f5f5', primary: '#00a991' }) })); }, onChange: function (font) {
                        onTemplateTypeChange(font === null || font === void 0 ? void 0 : font.value);
                    } }) })] }));
};
export default SearchFilter;
